<template>
  <div class="text-left">
    <div class="row">
      <div class="col">
        <label>Teaching Grades</label>
        <button
          v-if="
            !availableTeachingGrades.every(
              g => categorization.teachingGrade.indexOf(g.value) >= 0
            )
          "
          type="button"
          v-on:click="selectAllGrades"
          class="btn btn-outline-primary btn-sm ml-2"
        >
          Select All
        </button>
        <button
          v-if="
            availableTeachingGrades.every(
              g => categorization.teachingGrade.indexOf(g.value) >= 0
            )
          "
          type="button"
          v-on:click="categorization.teachingGrade = [0]"
          class="btn btn-outline-primary btn-sm ml-2"
        >
          Deselect All
        </button>
        <div
          v-for="grade in availableTeachingGrades"
          :key="grade.value"
          class="form-check"
        >
          <input
            class="form-check-input"
            type="checkbox"
            v-bind:value="grade.value"
            v-model="categorization.teachingGrade"
            v-bind:id="grade.description + 'x' + elementIdSuffix"
            @change="emitChange"
          />
          <label
            class="form-check-label"
            v-bind:for="grade.description + 'x' + elementIdSuffix"
          >
            {{ grade.description }}
          </label>
        </div>
      </div>
      <div class="col">
        <label>Award Level</label>
        <button
          v-if="
            !availableAwardLevels.every(
              l => categorization.awardLevel.indexOf(l.value) >= 0
            )
          "
          type="button"
          v-on:click="selectAllAwardLevels"
          class="btn btn-outline-primary btn-sm ml-2"
        >
          Select All
        </button>
        <button
          v-if="
            availableAwardLevels.every(
              l => categorization.awardLevel.indexOf(l.value) >= 0
            )
          "
          type="button"
          v-on:click="categorization.awardLevel = [0]"
          class="btn btn-outline-primary btn-sm ml-2"
        >
          Deselect All
        </button>
        <div
          v-for="level in availableAwardLevels"
          :key="level.value"
          class="form-check"
        >
          <input
            class="form-check-input"
            type="checkbox"
            v-bind:value="level.value"
            v-model="categorization.awardLevel"
            v-bind:id="level.description + 'x' + elementIdSuffix"
            @change="emitChange"
          />
          <label
            class="form-check-label"
            v-bind:for="level.description + 'x' + elementIdSuffix"
          >
            {{ level.description }}
          </label>
        </div>
      </div>
      <div class="col">
        <label>Teaching Subjects</label>
        <button
          v-if="!allSubjectsSelected()"
          type="button"
          v-on:click="selectAllSubjects"
          class="btn btn-outline-primary btn-sm ml-2"
        >
          Select All
        </button>
        <button
          v-if="allSubjectsSelected()"
          type="button"
          v-on:click="categorization.teachingSubject = [0]"
          class="btn btn-outline-primary btn-sm ml-2"
        >
          Deselect All
        </button>
        <div
          v-for="subject in availableTeachingSubjects"
          :key="subject.category"
          class="form-check"
        >
          <div class="accordian" v-if="subject.subjects.length > 1">
            <div class="row">
              <div class="col">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-bind:indeterminate.prop="
                    $getIndeterminateValue(
                      categorization.teachingSubject,
                      subject.subjects.map(s => s.value),
                      subject.category + 'x' + elementIdSuffix
                    )
                  "
                  v-bind:id="subject.category + 'x' + elementIdSuffix"
                  @change="
                    checkSubjectCategory(
                      categorization.teachingSubject,
                      subject.subjects.map(s => s.value)
                    )
                  "
                />
                <label
                  class="form-check-label"
                  v-bind:for="subject.category + 'x' + elementIdSuffix"
                >
                  {{ subject.category }}
                </label>
              </div>
              <div class="col-auto">
                <i
                  class="material-icons pointer "
                  v-bind:id="
                    'toggleIcon' + subject.category + 'x' + elementIdSuffix
                  "
                  data-toggle="collapse"
                  v-bind:href="
                    '#accordian' + subject.category + 'x' + elementIdSuffix
                  "
                  role="button"
                  aria-expanded="false"
                  >add</i
                >
              </div>
            </div>
            <div
              class="ml-4 collapse"
              v-bind:id="'accordian' + subject.category + 'x' + elementIdSuffix"
            >
              <div
                v-for="sub in subject.subjects"
                :key="sub.value + 'x' + elementIdSuffix"
              >
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-bind:value="sub.value"
                  v-bind:id="sub.value + 'x' + elementIdSuffix"
                  v-model="categorization.teachingSubject"
                  @change="emitChange"
                />
                <label
                  class="form-check-label"
                  v-bind:for="sub.value + 'x' + elementIdSuffix"
                >
                  {{ sub.description }}
                </label>
              </div>
            </div>
          </div>
          <div v-else>
            <input
              class="form-check-input"
              type="checkbox"
              v-bind:id="subject.category + 'x' + elementIdSuffix"
              v-bind:value="subject.subjects[0].value"
              v-model="categorization.teachingSubject"
              @change="emitChange"
            />
            <label
              class="form-check-label"
              v-bind:for="subject.category + 'x' + elementIdSuffix"
            >
              {{ subject.subjects[0].description }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!UserPreferences" class="row mt-4">
      <div v-if="!hideAwardType" class="col">
        <label>Award Type</label>
        <select
          name="typePicker"
          class="selectpicker d-block"
          data-style="btn-outline-primary"
          v-model="categorization.awardType"
          v-on:change="emitChange"
        >
          <option
            v-for="type in availableTypes"
            :key="type.value"
            v-bind:value="type.value"
          >
            {{ type.description }}
          </option>
        </select>
      </div>
      <div class="col">
        <label>States</label>
        <select
          name="statesPicker"
          class="selectpicker d-block"
          data-style="btn-outline-primary"
          multiple
          data-live-search="true"
          data-actions-box="true"
          data-selected-text-format="count"
          v-model="categorization.selectedStates"
          v-on:change="emitChange"
        >
          <option
            v-for="state in availableStates"
            :key="state.value"
            v-bind:value="state.value"
          >
            {{ state.description }}
          </option>
        </select>
        <p class="text-secondary">
          {{ getStatesList(categorization.selectedStates) }}
        </p>
      </div>
      <div class="col">
        <label>Restrictions</label>
        <select
          name="eligibilityPicker"
          class="selectpicker d-block"
          data-style="btn-outline-primary"
          multiple
          data-none-selected-text="No Restrictions"
          data-live-search="true"
          data-selected-text-format="count"
          v-model="categorization.eligibility"
          v-on:change="emitChange"
        >
          <optgroup label="Funds CAN'T be used for">
            <option
              v-for="el in cantEligibilities"
              :key="el.value"
              v-bind:value="el.value"
            >
              {{ el.description }}
            </option>
          </optgroup>
          <!--<optgroup label="Funds MUST be used for">
            <option
              v-for="el in mustEligibilities"
              :key="el.value"
              v-bind:value="el.value"
            >
              {{ el.description }}
            </option>
          </optgroup>-->
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import { teachingGrades } from "@/constants/TeachingGrades.js";
import { teachingSubjects } from "@/constants/TeachingSubjects.js";
import { states } from "@/constants/States.js";
import { awardLevels } from "@/constants/AwardLevels";
import { eligibilityRequirements } from "@/constants/EligibilityRequirements";
import { awardTypes } from "@/constants/AwardTypes.js";
import $ from "jquery";

export default {
  name: "GrantCategorization",
  components: {},
  props: {
    Grant: Object,
    ElementIdSuffix: String,
    UserPreferences: Object,
    HideAwardType: Boolean
  },
  data() {
    return {
      grant: this.Grant,
      elementIdSuffix: this.ElementIdSuffix,
      categorization: {
        teachingGrade: [0],
        teachingSubject: [0],
        awardLevel: [0],
        selectedStates: [0],
        eligibility: [0],
        awardType: 1
      },
      availableTeachingGrades: teachingGrades,
      availableTeachingSubjects: teachingSubjects,
      availableAwardLevels: awardLevels,
      availableStates: states,
      availableTypes: awardTypes,
      cantEligibilities: eligibilityRequirements.filter(
        e => e.group == "Can't"
      ),
      hideAwardType: this.HideAwardType
    };
  },
  watch: {
    Grant: async function() {
      this.categorization.teachingGrade = this.$createTeachingGradeValueList(
        this.Grant.Teaching_Grade
      );
      this.categorization.teachingSubject = this.$createTeachingSubjectValueList(
        this.Grant.Teaching_Subject
      );
      this.categorization.awardLevel = this.$createAwardLevelValueList(
        this.Grant.Award_Level
      );
      this.categorization.selectedStates = this.$createStateValueList(
        this.Grant.State
      );
      this.categorization.eligibility = this.$createEligibilityValueList(
        this.Grant.Eligibility
      );
      this.categorization.awardType = this.Grant.Award_Type;

      //update the pickers
      $("select[name=statesPicker]").val(this.categorization.selectedStates);
      $("select[name=eligibilityPicker]").val(this.categorization.eligibility);
      $("select[name=typePicker]").val(this.categorization.awardType);
      $(".selectpicker").selectpicker("refresh");
      this.emitChange();
    },
    UserPreferences: async function() {
      this.categorization.teachingGrade = this.$createTeachingGradeValueList(
        this.UserPreferences.Teaching_Grade
      );
      this.categorization.teachingSubject = this.$createTeachingSubjectValueList(
        this.UserPreferences.Teaching_Subject
      );
      this.categorization.awardLevel = this.$createAwardLevelValueList(
        this.UserPreferences.Award_Level
      );

      //update the pickers
      $("select[name=statesPicker]").val(this.categorization.selectedStates);
      $("select[name=eligibilityPicker]").val(this.categorization.eligibility);
      $(".selectpicker").selectpicker("refresh");
      this.emitChange();
    }
  },
  mounted() {
    var view = this;
    view.availableTeachingSubjects = view.availableTeachingSubjects.sort(
      view.$orderTeachingCategories
    );
    for (
      let index = 0;
      index < view.availableTeachingSubjects.length;
      index++
    ) {
      view.availableTeachingSubjects[
        index
      ].subjects = view.availableTeachingSubjects[index].subjects.sort(
        view.$orderByDescriptionAlphabetically
      );
    }
    $("select").selectpicker();
    $(document).ready(function() {
      view.availableTeachingSubjects.forEach(subject => {
        $("#accordian" + subject.category + "x" + view.elementIdSuffix)
          .on("show.bs.collapse", function() {
            $(this)
              .parent()
              .find(
                "#toggleIcon" + subject.category + "x" + view.elementIdSuffix
              )
              .text("remove");
          })
          .on("hide.bs.collapse", function() {
            $(this)
              .parent()
              .find(
                "#toggleIcon" + subject.category + "x" + view.elementIdSuffix
              )
              .text("add");
          });
      });
    });
    this.emitChange();
  },
  methods: {
    getStatesList(statesValueList) {
      var filteredStates = states.filter(s =>
        statesValueList.includes(s.value)
      );
      if (filteredStates.length == states.length) {
        return "All States";
      } else {
        return filteredStates.map(s => s.description).join(", ");
      }
    },
    allSubjectsSelected() {
      var teachingSubjectValue = 0;
      this.availableTeachingSubjects.forEach(subject => {
        subject.subjects.forEach(sub => (teachingSubjectValue += sub.value));
      });
      return (
        this.categorization.teachingSubject.reduce(function(a, b) {
          return a + b;
        }, 0) == teachingSubjectValue
      );
    },
    selectAllSubjects() {
      this.categorization.teachingSubject = [0];
      this.availableTeachingSubjects.forEach(subject => {
        subject.subjects.forEach(sub =>
          this.categorization.teachingSubject.push(sub.value)
        );
      });
      this.emitChange();
    },
    selectAllGrades() {
      this.categorization.teachingGrade = [0];
      this.availableTeachingGrades.forEach(grade => {
        this.categorization.teachingGrade.push(grade.value);
      });
      this.emitChange();
    },
    selectAllAwardLevels() {
      this.categorization.awardLevel = [0];
      this.availableAwardLevels.forEach(level => {
        this.categorization.awardLevel.push(level.value);
      });
      this.emitChange();
    },
    checkSubjectCategory(selectedSubjects, subjects) {
      if (
        selectedSubjects.filter(value => subjects.includes(value)).length > 0
      ) {
        selectedSubjects = selectedSubjects.filter(
          value => !subjects.includes(value)
        );
      } else {
        subjects.forEach(sub => selectedSubjects.push(sub));
      }
      this.categorization.teachingSubject = selectedSubjects;
      this.emitChange();
    },
    emitChange() {
      this.$emit("categorizationChange", this.categorization);
    },
    clearForm() {
      this.categorization.teachingGrade = [0];
      this.categorization.teachingSubject = [0];
      this.categorization.selectedStates = [0];
      this.categorization.eligibility = [0];
      this.categorization.awardLevel = [0];
      this.categorization.awardType = 1;
    }
  }
};
</script>
